import React from 'react';
import { useSonTranslation } from '../../../../translation/useSonTranslation';
import Btn from '../../../molecules/Btn';
import { Icons } from '../../../atoms/SVG';
import { TooltipPlacement } from '../../../atoms/Tooltip';

type PopUpButton = {
  onClick: () => void;
};

export function PopUpButton({ onClick }: PopUpButton) {
  const { t } = useSonTranslation('MediaInformation');

  return (
    <div className="media-information__button-container">
      <Btn
        svgSpriteId={Icons.EXPAND_ARROWS}
        text={t('popUp.text')}
        titleText={t('popUp.title')}
        hiddenText
        tooltipPlacement={TooltipPlacement.TOP}
        ariaHaspopup
        onClick={onClick}
      />
    </div>
  );
}
